module.exports = __webpack_public_path__ + "img/ic_close-1.ba38913b.svg";